module.exports = __webpack_public_path__ + "img/titulo-frente.76888fdb.png";